// Menus for My Pictures. View items are built at render time so the current view carries the dot.
export const File = [
  { type: 'item', text: 'View as a slide show' },
  { type: 'item', text: 'Set as desktop background' },
  { type: 'item', text: 'Save this picture' },
  { type: 'separator' },
  { type: 'item', text: 'Rename', disable: true },
  { type: 'item', text: 'Properties', disable: true },
  { type: 'separator' },
  { type: 'item', text: 'Close' },
];

export const viewMenu = view => [
  { type: 'item', text: 'Thumbnails', symbol: view === 'thumbs' ? 'circle' : undefined },
  { type: 'item', text: 'Filmstrip', symbol: view === 'filmstrip' ? 'circle' : undefined },
  { type: 'item', text: 'Details', symbol: view === 'details' ? 'circle' : undefined },
  { type: 'item', text: 'Tiles', disable: true },
  { type: 'item', text: 'List', disable: true },
  { type: 'separator' },
  { type: 'item', text: 'Refresh' },
];

export const Help = [{ type: 'item', text: 'About My Pictures' }];
